import { h } from 'preact';
import { memo } from 'preact/compat';

import Skeleton from '@mui/material/Skeleton';
import Divider from '@mui/material/Divider';

import LazyPropertyRecord from '../../components/propertyRecord/lazyPropertyRecord.jsx';
import { PropertiesTable } from './_common.js';
import FormAndList from '../../components/formAndList.jsx';

function Properties(_props) {
  const list = Array(11)
    .fill(null)
    .map((_, index) => <LazyPropertyRecord key={index} />);

  const title = <Skeleton width={120} />;

  return h(FormAndList, {
    form: (
      <>
        <Skeleton height={56} width={223} />
        <Divider />
        <Skeleton height={37} width={101} />
      </>
    ),
    list: <PropertiesTable>{list}</PropertiesTable>,
    listTitle: title,
    formTitle: title,
  });
}

export default memo(Properties);
